var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","color":"orange"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-tooltip',{attrs:{"bottom":"","color":"orange"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("default",null,{"click":_vm.click,"attrs":attrs,"on":on})]}}],null,true),model:{value:(_vm.copiedInner),callback:function ($$v) {_vm.copiedInner=$$v},expression:"copiedInner"}},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])]}}]),model:{value:(_vm.copied),callback:function ($$v) {_vm.copied=$$v},expression:"copied"}},[_c('span',[_vm._v(_vm._s(_vm.copiedTooltip))])])}
var staticRenderFns = []

export { render, staticRenderFns }